import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PrevSlide from '../assets/images/icon-blue-chev-left.svg'
import NextSlide from '../assets/images/icon-blue-chev-right.svg'

const propTypes = {
  list: PropTypes.array.isRequired,
}

class Testimonials extends Component {
  constructor(props) {
    super(props)
    this.state = {
      slideIndex: 0,
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e) {
    const { slideIndex } = this.state
    const maxSlides = this.props.list.length - 1

    if (e.currentTarget.id === 'next-chevron') {
      return slideIndex < maxSlides
        ? this.setState({ slideIndex: slideIndex + 1 })
        : null
    }

    return slideIndex > 0 ? this.setState({ slideIndex: slideIndex - 1 }) : null
  }

  renderSlide(parentClass) {
    const { slideIndex } = this.state
    return this.props.list.map((testimonial, i) => {
      const slideClass = `${parentClass}__item`
      const activeClass =
        slideIndex === i ? `${slideClass}--active` : `${slideClass}--in-active`
      return (
        <li
          className={`${slideClass} ${slideClass}--${i} ${activeClass}`}
          key={testimonial.text}
        >
          <p className="text text--lg">{`"${testimonial.text}"`}</p>
          <div className={`${parentClass}__person`}>
            <p className="text text--lg-bold">{testimonial.person}</p>
            <p className="text text--bold">{testimonial.company}</p>
          </div>
        </li>
      )
    })
  }

  render() {
    const { slideIndex } = this.state
    const { list } = this.props
    const parentClass = 'testimonials'
    const maxSlides = list.length - 1
    const prevActiveClass =
      slideIndex === 0 ? `${parentClass}__chev--disabled` : ''
    const nextActiveClass =
      slideIndex === maxSlides ? `${parentClass}__chev--disabled` : ''
    return (
      <div className={`${parentClass}`}>
        <div className={`${parentClass}__buttons`}>
          <img
            className={`${parentClass}__chev ${parentClass}__chev--prev ${prevActiveClass}`}
            id="prev-chevron"
            src={PrevSlide}
            alt="Prev Slide"
            onClick={this.handleClick}
          />
          <img
            className={`${parentClass}__chev ${parentClass}__chev--next ${nextActiveClass}`}
            id="next-chevron"
            src={NextSlide}
            alt="Next Slide"
            onClick={this.handleClick}
          />
        </div>
        <ul className={`${parentClass}__list`}>
          {this.renderSlide(parentClass)}
        </ul>
      </div>
    )
  }
}

Testimonials.propTypes = propTypes

export default Testimonials



// WEBPACK FOOTER //
// ./src/components/Testimonials.js